import { Button, Modal } from 'antd';

type IncidenceRequestForwardConfirmModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  confirmLoading?: boolean;
};

export const IncidenceRequestForwardConfirmModal = ({
  open,
  onClose,
  onConfirm,
  confirmLoading = false,
}: IncidenceRequestForwardConfirmModalProps) => {
  return (
    <Modal
      open={open}
      title="Marcar supervisor incorrecto"
      onCancel={onClose}
      footer={null}
      destroyOnHidden
      maskClosable={false}
      centered
      width={510}
      className="incidence-request-submit-modal incidence-request-forward-modal"
      getContainer={false}
      data-cy="incidence-request-forward-modal"
    >
      <p className="incidence-request-submit-modal-description">
        Esta solicitud será enviada al área de Recursos Humanos con el estatus
        de supervisor incorrecto y ya no aparecerá en tu lista de solicitudes
        por aprobar. ¿Deseas continuar?
      </p>

      <div className="incidence-request-submit-modal-footer">
        <Button
          className="incidence-request-submit-modal-btn incidence-request-submit-modal-btn-secondary"
          onClick={onClose}
          data-cy="incidence-request-forward-cancel-btn"
        >
          Cancelar
        </Button>
        <Button
          type="primary"
          className="incidence-request-submit-modal-btn"
          onClick={onConfirm}
          loading={confirmLoading}
          data-cy="incidence-request-forward-confirm-btn"
        >
          Confirmar
        </Button>
      </div>
    </Modal>
  );
};
